import styled from "styled-components";
import { themes } from "../../Utils/themes";
import { device } from "../../Utils/device";

export const PurchaseFlowList = styled.ul`
  border: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: ${themes.colors.white};
  margin: 0 auto;
  max-width: 1200px;
  display: flex;
  flex-flow: column;
  align-items: center;
  @media ${device.desktop} {
    display: flex;
    flex-flow: initial;
    align-items: initial;
    gap: 10px;
  }
`;

export const PurchaseFlowItem = styled.li`
  background-color: ${themes.colors.background};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto 10px;
  width: 100%;
  max-width: 190px;
  padding: 14px 20px;
  border-radius: 12px;
  box-shadow: 0px 8px 16px -2px rgba(10, 10, 10, 0.1),
    2px 1px 10px 2px rgba(10, 10, 10, 0.02);
  outline: 3px solid rgba(236, 193, 0, 0.5);
  outline-offset: -5px;

  @media ${device.desktop} {
    margin: 0 auto 10px;
    padding: 24px 38px;
  }
`;

export const PurchaseFlowLabel = styled.label`
  background-color: ${themes.colors.attention};
  color: ${themes.colors.text};
  border-radius: 19px;
  display: block;
  font-size: ${themes.textSize.s3};
  font-weight: 700;
  line-height: 22px;
  margin: 8px 0;
  max-width: 100%;
  padding: 6px;
  text-align: center;
  width: 160px;
  @media ${device.desktop} {
    font-size: ${themes.textSize.m1};
    margin: 16px 0;
    padding: 8px;
    width: 100%;
  }
`;

export const PurchaseFlowText = styled.span`
  font-size: ${themes.textSize.m1};
  margin: 8px auto 0;
  max-width: 100%;
  font-weight: 600;
  height: 70px;
  border: 2px solid rgba(236, 193, 0, 0.5);
  background-color: ${themes.colors.white};
  padding: 20px 10px;
  border-radius: 10px;
  @media ${device.desktop} {
    width: auto;
    height: 90px;
    margin: 16px auto 0;
    padding: 25px 15px;
  }
`;

export const ImgWrap = styled.div`
  max-width: 80px;
  width: 110px;
  margin: auto;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  min-height: 90px;
  @media ${device.desktop} {
    width: 140px;
    min-height: 120px;
  }
`;

export const FlowImg = styled.img`
  max-height: 90px;
  @media ${device.desktop} {
    width: 140px;
    max-height: 120px;
  }
`;

export const ArrowImg = styled.img`
  width: 20px;
  transform: rotate(90deg);
  @media ${device.desktop} {
    width: 30px;
    transform: initial;
  }
`;
